import { render, staticRenderFns } from "./BaseInputRadio.vue?vue&type=template&id=2aa5e06f&scoped=true&"
import script from "./BaseInputRadio.vue?vue&type=script&lang=js&"
export * from "./BaseInputRadio.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputRadio.vue?vue&type=style&index=0&id=2aa5e06f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa5e06f",
  null
  
)

export default component.exports